const DEFAULTS = { showFreeTrial: false, showViewRepo: false };

let cached = null;
let promise = null;

export async function loadAppConfig() {
  if (cached) return cached;
  if (!promise) {
    promise = fetch("/app-config.json")
      .then((r) => (r.ok ? r.json() : {}))
      .catch(() => ({}))
      .then((data) => {
        cached = { ...DEFAULTS, ...data };
        return cached;
      });
  }
  return promise;
}

export function getAppConfig() {
  return cached ?? DEFAULTS;
}
